import { axiosPatch, axiosPost } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants"

async function UpdateSpeakers({ setBtnLoading, btnLoading,
    profilePic, name, description, speakerId, position }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            // console.log("section = ", section)
            await axiosPatch({
                endpoint: `${ApiConstants.UPDATE_PE_SPEAKER}/${speakerId}`,
                jsonBody: JSON.stringify({
                    name: name,
                    position: position,
                    description: description
                })
            })

            //upload pdf here...
            if (profilePic) {
                const formData = new FormData();
                formData.append('file', profilePic);

                let res = await axiosPost({
                    endpoint: `${ApiConstants.UPLOAD_PE_PIC}/${speakerId}`,
                    formData: formData
                })
                console.log('File uploaded successfully! = ', res);
            }
            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default UpdateSpeakers;